import { type HTMLAttributes } from 'react';

type ProgressVariant = 'default' | 'stress';

interface ProgressProps extends HTMLAttributes<HTMLDivElement> {
  value: number;
  max?: number;
  variant?: ProgressVariant;
  pixel?: boolean;
  loading?: boolean;
}

export function Progress({
  value,
  max = 100,
  variant = 'default',
  pixel = false,
  loading = false,
  className = '',
  ...props
}: ProgressProps) {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
  const variantClass = variant !== 'default' ? `progress-${variant}` : '';
  const pixelClass = pixel ? 'progress-pixel' : '';
  const loadingClass = loading ? 'progress-loading' : '';

  return (
    <div
      className={`progress-bar ${variantClass} ${pixelClass} ${loadingClass} ${className}`.trim()}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      {...props}
    >
      <div
        className="progress-fill"
        style={{ width: loading ? undefined : `${percentage}%` }}
      />
    </div>
  );
}
